import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

export const getEditTypeCounts = {
  name: "getEditTypeCounts" as const,
  input: z.object({
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({
    counts: z.array(z.object({ kind: z.string(), count: z.number() })),
  }),
};
